// src/constants/workshops.js

export const workshops = [
    {
      id: 'workshop1',
      title: 'Repique Club',
      experienceLevel: 'Intermediate',
      type: 'Drumming',
      instructor: 'Rob Arcari',
      duration: '1.5 hours',
      location: 'Wizard Tone Studios',
      capacity: 'TBC',
      equipment: 'BYO Repique, sticks, strap',
      prerequisites: 'You should be comfortable playing the repique with one stick and one hand to some degree',
      registrationUrl: 'https://events.humanitix.com/repique-club?hxchl=hex-pfl'
    },
    {
      id: 'workshop2',
      title: 'Bahia Samba Dance',
      experienceLevel: 'Open to all',
      type: 'Dancing',
      instructor: 'Jean Stora',
      duration: '1.5 hours',
      location: 'Cheltenham Community Centre',
      capacity: 'TBC',
      equipment: 'Comfy clothes allowing a wide range of movement. Jazz dance shoes or sneakers. Bring water and a towel. You will sweat.',
      prerequisites: 'No prior experience needed',
      registrationUrl: 'https://events.humanitix.com/axe-bahia-dance-with-jean-stora-adelaide-samba-encontro?hxchl=hex-pfl'
    },
    {
      id: 'workshop3',
      title: 'The Drums of Estácio de Sá',
      experienceLevel: 'Intermediate',
      type: 'Drumming',
      instructor: 'Rob Mair',
      duration: '1.5 hours',
      location: 'Wizard Tone Studios',
      capacity: 'TBC',
      equipment: 'BYO instruments, sticks and straps',
      prerequisites: 'Suitable for players with some experience and proficiency in at least one instrument.',
      registrationUrl: 'https://events.humanitix.com/the-drums-of-estacio-de-sa-with-rob-mair-adelaide-samba-encontro?hxchl=hex-pfl'
    },
    {
      id: 'workshop4',
      title: 'Brazilian Funk',
      experienceLevel: 'Open to all',
      type: 'Dancing',
      instructor: 'Karla Mura',
      duration: '1.5 hours',
      location: 'Cheltenham Community Centre',
      capacity: 'TBC',
      equipment: 'Comfortable clothing and dance shoes recommended',
      prerequisites: 'No prior experience needed',
      registrationUrl: 'https://events.humanitix.com/brazilian-funk-with-karla-mura-adelaide-samba-encontro?hxchl=hex-pfl'
    },
    {
      id: 'workshop5',
      title: 'Bahia Samba Percussion',
      experienceLevel: 'Intermediate',
      type: 'Drumming',
      instructor: 'Jean Stora',
      duration: '1.5 hours',
      location: 'Wizard Tone Studios',
      capacity: 'TBC',
      equipment: 'Bring your own percussion instrument(s) as they will not be provided',
      prerequisites: 'Suitable for players with some experience and proficiency in at least one instrument.',
      registrationUrl: 'https://events.humanitix.com/bahia-samba-percussion-workshop-with-jean-stora-adelaide-samba-encontro?hxchl=hex-pfl'
    },
    {
      id: 'workshop6',
      title: 'Queen of Drums: Understanding Musicality & Movement to the Bateria',
      experienceLevel: 'Open to all',
      type: 'Dancing',
      instructor: 'Denise Kayan & Rob Arcari',
      duration: '1.5 hours',
      location: 'Cheltenham Community Centre',
      capacity: 'TBC',
      equipment: 'Bring water, comfortable clothes & runners.',
      prerequisites: 'This workshop will be beneficial for dancers of all levels, and will be accompanied by live drums.',
      registrationUrl: 'https://events.humanitix.com/how-to-dance-like-a-rainha-de-bateria-with-denise-kayan-and-rob-arcari-adelaide-samba-encontro?hxchl=hex-pfl'
    }
  ];
  
  // Helper functions for workshops
  export const getExperienceLevelColor = (level) => {
    switch(level) {
      case 'Open to all':
        return 'bg-green-100 text-green-800';
      case 'Intermediate':
        return 'bg-blue-100 text-blue-800';
      case 'Advanced':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  
